import { PropsWithChildren } from 'lib-shared-types-utils';
import { useCallback, useRef, useState } from 'react';


type EmailReplyQuoteProps = PropsWithChildren;

/**
 * Renders children in a collapsible quote section.
 *
 * Note: Because this component is used in shadow-dom the we cannot use Habla,
 * and the styles the way they are normally used.
 */
export const EmailReplyQuote = ({
  children,
}: EmailReplyQuoteProps): JSX.Element => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState(0);

  const toggleQuote = useCallback(
    () => setMaxHeight(maxHeight ? 0 : contentRef.current?.offsetHeight ?? 0),
    [maxHeight],
  );

  return (
    <div className="reply-quote-root">
      <div>
        <button className="reply-quote-button" onClick={toggleQuote}>
          ···
        </button>
      </div>
      <div style={{ maxHeight }} className="reply-quote-content">
        <div ref={contentRef}>{children}</div>
      </div>
    </div>
  );
};
